export default __webpack_public_path__ + "static/media/pointer.645a9ade.svg";